"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames2 = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _moment = _interopRequireDefault(require("moment"));
var _Tooltip = _interopRequireWildcard(require("../../../ui/Tooltip"));
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _CircleLoader = _interopRequireDefault(require("../../../ui/CircleLoader"));
var _price = require("../../../../helpers/price");
var _withProps = _interopRequireDefault(require("./withProps"));
var _arrow = _interopRequireDefault(require("./arrow.svg"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DELTA_FOR_EMPTY_PRICE = "".concat(2 / 3 * 100, "%");
var chartMapper = R.addIndex(R.map);
var getMonthNumber = function getMonthNumber(timestamp) {
  return (0, _moment.default)(timestamp, 'X').format('M');
};
var getMonthYear = function getMonthYear(timestamp) {
  return (0, _moment.default)(timestamp, 'X').format('YYYY');
};
var getMonthNameByNumber = function getMonthNameByNumber(number) {
  return (0, _moment.default)(number, 'M').format('MMMM');
};
var generateMonthUniqKey = function generateMonthUniqKey(timestamp) {
  return R.join('-', [getMonthNumber(timestamp), getMonthYear(timestamp)]);
};
var parseMonthUniqKey = function parseMonthUniqKey(key) {
  return R.call(R.pipe(R.split('-'), function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      number = _ref2[0],
      year = _ref2[1];
    return {
      number: number,
      year: year
    };
  }), key);
};
var getSortValue = function getSortValue(uniqKey) {
  return R.call(R.pipe(parseMonthUniqKey, function (_ref3) {
    var number = _ref3.number,
      year = _ref3.year;
    return (0, _moment.default)("".concat(number, " ").concat(year), 'M YYYY').format('X');
  }, Number), uniqKey);
};
var Bar = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: ", "\n"])), function (props) {
  return props.theme.primaryColor;
});
var PriceChart = function PriceChart(_ref4) {
  var chart = _ref4.chart,
    currency = _ref4.currency,
    title = _ref4.title,
    onChangeNext = _ref4.onChangeNext,
    onChangePrev = _ref4.onChangePrev,
    onClickBar = _ref4.onClickBar;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
    t = _useTranslation.t;
  var months = (0, _react.useMemo)(function () {
    return R.call(R.pipe(R.reduce(function (acc, _ref5) {
      var timestamp = _ref5.day;
      return R.over(R.lensProp(generateMonthUniqKey(timestamp)), function (count) {
        return count ? R.inc(count) : 1;
      }, acc);
    }, {}), R.toPairs, R.sort(function (_ref6, _ref7) {
      var _ref8 = _slicedToArray(_ref6, 1),
        uniqKeyA = _ref8[0];
      var _ref9 = _slicedToArray(_ref7, 1),
        uniqKeyB = _ref9[0];
      return getSortValue(uniqKeyA) - getSortValue(uniqKeyB);
    }), R.map(function (_ref0) {
      var _ref1 = _slicedToArray(_ref0, 2),
        key = _ref1[0],
        count = _ref1[1];
      return {
        name: getMonthNameByNumber(parseMonthUniqKey(key).number),
        percent: count * 100 / chart.length
      };
    })), chart);
  }, [chart]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.title,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), R.isEmpty(chart) ? /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.loaderContainer
  }, /*#__PURE__*/_react.default.createElement(_CircleLoader.default, null)) : /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.controls
  }, onChangePrev && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.control, _styles.default.prev)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    height: _Button.HEIGHTS.FLUID,
    width: _Button.WIDTHS.FLUID,
    className: _styles.default.button,
    icon: _arrow.default,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: onChangePrev
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.control, _styles.default.next)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    height: _Button.HEIGHTS.FLUID,
    width: _Button.WIDTHS.FLUID,
    className: _styles.default.button,
    icon: _arrow.default,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: onChangeNext
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.list
  }, chartMapper(function (_ref10, index) {
    var timestamp = _ref10.day,
      delta = _ref10.delta,
      price = _ref10.price;
    return [index > 1 && (0, _moment.default)(timestamp, 'X').format('D') === '1' && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.divider,
      key: "".concat(timestamp, "--divider")
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames2.default)(_styles.default.item, _defineProperty({}, _styles.default.noPrice, !price)),
      key: timestamp
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.barContainer,
      onClick: onClickBar ? function () {
        return onClickBar((0, _moment.default)(timestamp, 'X'));
      } : undefined
    }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      content: price ? /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.tooltipBody
      }, (0, _price.preparePriceForRender)(price[currency.code], currency.symbol), onClickBar && /*#__PURE__*/_react.default.createElement(_Button.default, {
        activeTheme: _Button.THEMES.PURPLE,
        className: _styles.default.tooltipBodyButton,
        fontFamily: _Button.FONT_FAMILIES.REGULAR,
        size: _Button.SIZES.TINY,
        theme: _Button.THEMES.GRAY
      }, t('CHART_ITEM_WITH_PRICE_BUTTON'))) : t('CHART_ITEM_WITH_EMPTY_PRICE_TEXT'),
      enterDelay: _Tooltip.ENTER_DELAY.NOW,
      placement: _Tooltip.PLACEMENTS.TOP,
      trigger: [_Tooltip.TRIGGERS.HOVER]
    }, /*#__PURE__*/_react.default.createElement(Bar, {
      className: _styles.default.bar,
      style: {
        height: delta ? "".concat(delta, "%") : DELTA_FOR_EMPTY_PRICE
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.day
    }, (0, _moment.default)(timestamp, 'X').format('dd'))))), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.date
    }, (0, _moment.default)(timestamp, 'X').format('DD')))];
  }, chart)), !R.isEmpty(months) && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.months
  }, R.map(function (_ref11) {
    var name = _ref11.name,
      percent = _ref11.percent;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.month,
      key: name,
      style: {
        width: "".concat(percent, "%")
      }
    }, name);
  }, months))));
};
PriceChart.propTypes = {
  currency: _propTypes.default.shape({
    code: _propTypes.default.string.isRequired,
    symbol: _propTypes.default.string.isRequired
  }).isRequired,
  title: _propTypes.default.string.isRequired,
  onChangeNext: _propTypes.default.func,
  onChangePrev: _propTypes.default.func,
  onClickBar: _propTypes.default.func
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(PriceChart);